//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

//local imports
import { CurrentUserModel } from '@core/data/models';

@Component({
  selector: 'user-details',
  standalone: false,
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetailsComponent {
  public currentUser = input<CurrentUserModel | null>(null);
}